exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.delayed-chart-scroll-overlay{position:relative}.delayed-chart-scroll-overlay:focus{outline:none}.delayed-chart-scroll-overlay:before{position:absolute;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.05);z-index:10;content:\"\";cursor:pointer;display:none}.delayed-chart-scroll-overlay:after{content:\"Verwenden Sie Strg + Scrollen zum Zoomen im Diagramm\";position:absolute;font-size:2em;z-index:11;top:50%;left:50%;transform:translate(-50%,-50%);color:grey;text-align:center;display:none}.delayed-chart-scroll-overlay.enter:after,.delayed-chart-scroll-overlay.enter:before{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/_delayedScroll.scss
// module id = 90
// module chunks = 0